import React from 'react';
export function Spinner() {
    return <div className='Loader'>
        <div className='skcube1 skcube'></div>
        <div className='skcube skcube'></div>
        <div className='skcube4 skcube'></div>
        <div className='skcube3 skcube'></div>
    </div>;
}
